import {
  type ResponsiveBreakpoint,
  type ResponsiveOption,
} from '../../types/responsiveOption';

export function mapResponsiveOption<K extends string, V>(
  defaultValue: K,
  responsiveBreakpoint: ResponsiveBreakpoint<K> | undefined,
  mapping: Record<K, V>
): ResponsiveOption<V> {
  if (!responsiveBreakpoint) {
    return mapping[defaultValue];
  }
  return {
    default: mapping[defaultValue],
    ...(responsiveBreakpoint.xs != null && {
      xs: mapping[responsiveBreakpoint.xs],
    }),
    ...(responsiveBreakpoint.sm != null && {
      sm: mapping[responsiveBreakpoint.sm],
    }),
    ...(responsiveBreakpoint.md != null && {
      md: mapping[responsiveBreakpoint.md],
    }),
    ...(responsiveBreakpoint.lg != null && {
      lg: mapping[responsiveBreakpoint.lg],
    }),
    ...(responsiveBreakpoint.xl != null && {
      xl: mapping[responsiveBreakpoint.xl],
    }),
  };
}
